import React from 'react';
import { faEdit, faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const colummns = (editAction, disabledAction, config) => {
    return [
      {
        name: 'Tipo',
        selector: 'description',
        sortable: true,
      },
      {
        name: 'Prefijo',
        selector: 'prefijo',
        sortable: true,
      },
      {...(config.use_correlative_types &&
      {
        name: 'Correlativo actual',
        selector: 'correlative',
        sortable: true,
      })},
      {
        name: 'Estado',
        selector: 'status',
        sortable: true,
        cell: row => {
           if (parseInt(row.status)) {
              return <span className="badge badge-success">Activo</span>
           } else {
              return <span className="badge badge-danger">Inactivo</span>
           }
          
        }
      },
      {
          name: 'Opciones',
          right: true,
          cell: row => {
            return <>
              <button
                  type="button"
                  className="btnx btnx-warn mr-1 mt-1"
                  onClick={() => disabledAction(row)}
              >
                  <FontAwesomeIcon icon={parseInt(row.status) ? faLockOpen : faLock} />
              </button>
              <button 
                  type="button"
                  className="btnx btnx-warn mr-1 mt-1"
                  onClick={() => editAction(row)}
              >
                  <FontAwesomeIcon icon={faEdit} />
              </button>
            </>
          
          }
      }
    ];
};

export {
    colummns,
}